export const tabletBreakPoint = 1025
export const phoneBreakPoint = 500
